module.exports = __webpack_public_path__ + "img/alerus.8b6dce4b.svg";